import React, { useState, useEffect } from "react";
import {
  Home,
  UserPlus,
  ClipboardCheck,
  DoorOpen,
  ChevronLeft,
  ChevronDown,
  CircleDollarSign,
  GraduationCap,
  Drill,
  Truck,
  Settings,
  LucideFileLineChart,
  RocketIcon,
  HelpCircle,
  Image,
  FolderOpen,
  Building2,
  ExternalLink,
  Link2,
} from "lucide-react";
import logoLisual from "../../media/lisualpro.png";
import defaultLogo from "../../media/lisualLogo.jpg";
import { useNavigate } from "react-router-dom";
import NewProject from "./NewProject.tsx";
import PaymentModal from "./PaymentModal.tsx";
import OnboardingSchedule from "./OnboardingSchedule.tsx";
import InstallationSchedule from "./InstallationSchedule.tsx";
import CamDelivery from "./CamDelivery.tsx";
import CustomerConfig from "./EditCustomer.tsx";
import CustomerUsers from "./CustomerUsers.tsx";
import ReinversionModal from "./ReinversionModal.tsx";
import ArchiveCameras from "./ArchiveCameras.tsx";
import LicenseModal from "./LicenseModal.tsx";
import { LogoUploader } from "../../logos/components";
import { ObrasModal } from "../../obras/components";
import CustomerContent from "./CustomerContent.tsx";

const CustomerSidebar = ({
  isSidebarOpen,
  toggleSidebar,
  activeTab,
  setActiveTab,
  logo,
  customerId,
  onProjectCreated,
  customerData,
  sidebarButtons = [],
  openLogoRequest = 0,
  onLogoSaved,
}) => {
  const navigate = useNavigate();
  const [showNewProjectModal, setShowNewProjectModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);
  const [showInstallationModal, setShowInstallationModal] = useState(false);
  const [showCameraSetupModal, setShowCameraSetupModal] = useState(false);
  const [showCustomerConfigModal, setShowCustomerConfigModal] = useState(false);
  const [showUsersModal, setShowUsersModal] = useState(false);
  const [onUserCreated, setOnUserCreated] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [showArchiveCamerasModal, setShowArchiveCamerasModal] = useState(false);
  const [showLicenseModal, setShowLicenseModal] = useState(false);
  const [showLogoUploaderModal, setShowLogoUploaderModal] = useState(false);
  const [showContentModal, setShowContentModal] = useState(false);
  const [showObrasModal, setShowObrasModal] = useState(false);
  const [displayedLogo, setDisplayedLogo] = useState(logo);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  useEffect(() => {
    setDisplayedLogo(logo);
  }, [logo]);



  const navigateToPage = (page) => {
    navigate(`/metrics/0/0/`);
  };

  // La campanita pide abrir el cargador de logo (aviso "Falta de logo")
  useEffect(() => {
    if (openLogoRequest > 0) setShowLogoUploaderModal(true);
  }, [openLogoRequest]);

  const handleLogoSaved = () => {
    onLogoSaved?.();
    if (logo) {
      const separator = logo.includes('?') ? '&' : '?';
      setDisplayedLogo(`${logo}${separator}t=${Date.now()}`);
    }
  };

  const allMenuItems = [
    { name: "Inicio", icon: <Home size={24} />, disabled: false },
    {
      name: "Soporte",
      icon: <HelpCircle size={24} />,
      disabled: false,
      submenu: [
        { name: "Capacitación", icon: <GraduationCap size={20} />, disabled: false },
        { name: "Envío de Cámara", icon: <Truck size={20} />, disabled: false },
        { name: "Instalación", icon: <Drill size={20} />, disabled: false },
        // { name: "Ayuda", icon: <HelpCircle size={20} />, disabled: false },
        // { name: "Primeros Pasos", icon: <RocketIcon size={20} />, disabled: false },
      ],
    },
    { name: "Usuarios", icon: <UserPlus size={24} />, disabled: false },
    { name: "Terminados", icon: <ClipboardCheck size={24} />, disabled: false },
    { name: "Publicidad", icon: <RocketIcon size={24} />, disabled: false },
    { name: "Contenido", icon: <FolderOpen size={24} />, disabled: false },
    { name: "Agrupa por Obras", icon: <Building2 size={24} />, disabled: false },
    // Se abre en el área principal (no es un modal): ver linksPersonalizados/LinksPersonalizados.jsx
    { name: "Link personalizados", icon: <Link2 size={24} />, disabled: false },
    {
      name: "Configuración",
      icon: <Settings size={24} />,
      disabled: false,
      submenu: [
        { name: "Logo", icon: <Image size={20} />, disabled: false },
        { name: "Configuración General", icon: <Settings size={20} />, disabled: false },
        { name: "Licencias", icon: <CircleDollarSign size={20} />, disabled: false },
      ],
    },
  ];

  const menuItems = allMenuItems.filter(item => true);

  const handleImageError = (e) => {
    e.target.src = defaultLogo;
  };

  const handleMenuClick = (itemName) => {
    if (itemName === "Alta Cámara") {
      setShowNewProjectModal(true);
    } else if (itemName === "Abonar") {
      setShowPaymentModal(true);
    } else if (itemName === "Capacitación") {
      setShowOnboardingModal(true);
    } else if (itemName === "Instalación") {
      setShowInstallationModal(true);
    } else if (itemName === "Envío de Cámara") {
      setShowCameraSetupModal(true);
    } else if (itemName === "Configuración General") {
      setShowCustomerConfigModal(true);
    } else if (itemName === "Usuarios") {
      setShowUsersModal(true);
    } else if (itemName === "Publicidad") {
      setShowReferralModal(true);
    } else if (itemName === "Terminados") {
      setShowArchiveCamerasModal(true);
    } else if (itemName === "Logo") {
      setShowLogoUploaderModal(true);
    } else if (itemName === "Contenido") {
      setShowContentModal(true);
    } else if (itemName === "Agrupa por Obras") {
      setShowObrasModal(true);
    } else if (itemName === "Licencias") {
      setShowLicenseModal(true);
    } else if (itemName === "Análisis IA") {
      navigateToPage();
    } else {
      setActiveTab(itemName);
    }
  };

  console.log("customerData in CustomerSidebar:", customerData);

  return (
    <>
      <aside
        className={`
          hidden lg:block fixed inset-y-0 left-0 z-30 transition-all duration-300 ease-in-out
          bg-gradient-to-br from-blue-200 via-blue-100 to-white border-r border-blue-200 shadow-lg overflow-y-auto
          ${isSidebarOpen ? "w-64" : "w-0"}
        `}
      >
        <div className="p-6 bg-blue-100">
          <img
            src={displayedLogo || defaultLogo}
            alt="Logo"
            className="h-40 w-auto mx-auto mb-6"
            style={{ borderRadius: "10%" }}
            onError={handleImageError}
          />
        </div>

        <nav className="px-4">
          <ul className="space-y-3">
            {menuItems.map((item) => (
              <li key={item.name}>
                <div
                  className={`
                    transition-all duration-200 relative
                    ${activeTab === item.name && !item.disabled
                      ? "bg-white text-blue-800 shadow-md border-2 border-blue-300"
                      : item.disabled
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200"
                      : "bg-white/80 hover:bg-white text-gray-700 hover:text-blue-700 border border-blue-100"
                    }
                    rounded-xl backdrop-blur-sm
                  `}
                  onClick={() => {
                    if (item.disabled) return;
                    if (item.submenu) {
                      setOpenSubmenu((prev) => (prev === item.name ? null : item.name));
                    } else {
                      handleMenuClick(item.name);
                    }
                  }}
                >
                  <div
                    className={`flex items-center justify-between p-3 ${item.disabled ? "opacity-50" : "cursor-pointer"}`}
                  >
                    <div className="flex items-center">
                      <span className={`${activeTab === item.name && !item.disabled ? "text-blue-600" : "text-gray-500"}`}>
                        {item.icon}
                      </span>
                      <span className="ml-3 font-medium">{item.name}</span>
                    </div>

                    {item.submenu && (
                      <ChevronDown
                        size={18}
                        className={`text-gray-400 transition-transform duration-200 ${openSubmenu === item.name ? "rotate-180" : ""}`}
                      />
                    )}
                  </div>
                </div>

                {item.submenu && openSubmenu === item.name && (
                  <ul className="mt-2 ml-4 space-y-2 border-l-2 border-blue-200 pl-3">
                    {item.submenu.map((subItem) => (
                      <li
                        key={subItem.name}
                        className={`
                          transition-all duration-200
                          ${activeTab === subItem.name
                            ? "bg-white text-blue-800 shadow-md border-2 border-blue-300"
                            : "bg-white/80 hover:bg-white text-gray-700 hover:text-blue-700 border border-blue-100"
                          }
                          rounded-xl backdrop-blur-sm cursor-pointer
                        `}
                        onClick={() => handleMenuClick(subItem.name)}
                      >
                        <div className="flex items-center p-2.5">
                          <span className={`${activeTab === subItem.name ? "text-blue-600" : "text-gray-500"}`}>
                            {subItem.icon}
                          </span>
                          <span className="ml-3 text-sm font-medium">{subItem.name}</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}

            {sidebarButtons.map((item, index) => (
              <li key={`sidebar-link-${index}`} className={index === 0 ? "pt-4 mt-4 border-t border-blue-200" : ""}>
                <button
                  onClick={() => window.open(item.url, "_blank", "noopener,noreferrer")}
                  className="w-full flex items-center p-3 bg-white/80 hover:bg-white text-gray-700 hover:text-blue-700 rounded-xl transition-colors border border-blue-100"
                >
                  <ExternalLink size={24} className="text-gray-500" />
                  <span className="ml-3 font-medium">{item.name}</span>
                </button>
              </li>
            ))}


            <li className="pt-4 mt-4 border-t border-blue-200">
              <button
                onClick={() => {
                    navigate("/");
                    localStorage.clear();
                }}
                className="w-full flex items-center p-3 bg-white/80 text-red-600 hover:bg-white rounded-xl transition-colors border border-blue-100"
              >
                <DoorOpen />
                <span className="ml-3 font-medium">Salir</span>
              </button>
            </li>
          </ul>
        </nav>

        

        <div className="p-6">
          <img src={logoLisual} alt="Logo Lisual" className="h-12 w-auto ml-auto" />
        </div>
      </aside>

      {/* Mobile sidebar */}
      {isSidebarOpen && (
        <div className="lg:hidden fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-black/30 backdrop-blur-sm transition-opacity duration-300"
            onClick={() => toggleSidebar(false)}
          />
          <div className="absolute inset-y-0 left-0 w-[85%] max-w-sm bg-gradient-to-r from-blue-100 to-white shadow-xl">
            <div className="flex flex-col h-full">
              <div className="p-6 border-b border-blue-100">
                <div className="flex items-center justify-between">
                  <img
                    src={displayedLogo || defaultLogo}
                    alt="Logo"
                    className="h-8 w-auto"
                    onError={handleImageError}
                  />
                  <button
                    onClick={() => toggleSidebar(false)}
                    className="p-2.5 rounded-lg hover:bg-blue-50 transition-colors"
                  >
                    <ChevronLeft size={24} className="text-gray-600" />
                  </button>
                </div>
              </div>

              <nav className="flex-1 overflow-y-auto p-4 space-y-2">
                {menuItems.map((item) => (
                  <div key={item.name}>
                    <button
                      onClick={() => {
                        if (item.disabled) return;
                        if (item.submenu) {
                          setOpenSubmenu((prev) => (prev === item.name ? null : item.name));
                        } else {
                          handleMenuClick(item.name);
                          toggleSidebar(false);
                        }
                      }}
                      className={`
                        w-full flex items-center p-4 rounded-xl transition-all duration-200
                        ${activeTab === item.name
                          ? "bg-white text-blue-600 shadow-md border border-blue-100"
                          : "hover:bg-white/80 text-gray-600"
                        }
                      `}
                      disabled={item.disabled}
                    >
                      <div className="relative">
                        {React.cloneElement(item.icon, { size: 20, className: "flex-shrink-0" })}
                      </div>
                      <span className="ml-3 font-medium truncate">{item.name}</span>

                      {item.submenu ? (
                        <ChevronDown
                          size={18}
                          className={`ml-auto text-gray-400 transition-transform duration-200 ${openSubmenu === item.name ? "rotate-180" : ""}`}
                        />
                      ) : activeTab === item.name && (
                        <span className="ml-auto w-2 h-2 bg-blue-500 rounded-full" />
                      )}
                    </button>

                    {item.submenu && openSubmenu === item.name && (
                      <div className="mt-2 ml-6 space-y-2 border-l-2 border-blue-200 pl-3">
                        {item.submenu.map((subItem) => (
                          <button
                            key={subItem.name}
                            onClick={() => {
                              handleMenuClick(subItem.name);
                              toggleSidebar(false);
                            }}
                            className={`
                              w-full flex items-center p-3 rounded-xl transition-all duration-200
                              ${activeTab === subItem.name
                                ? "bg-white text-blue-600 shadow-md border border-blue-100"
                                : "hover:bg-white/80 text-gray-600"
                              }
                            `}
                          >
                            <div className="relative">
                              {React.cloneElement(subItem.icon, { size: 18, className: "flex-shrink-0" })}
                            </div>
                            <span className="ml-3 text-sm font-medium truncate">{subItem.name}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

                {sidebarButtons.map((item, index) => (
                  <button
                    key={`mobile-sidebar-link-${index}`}
                    onClick={() => {
                      window.open(item.url, "_blank", "noopener,noreferrer");
                      toggleSidebar(false);
                    }}
                    className={`w-full flex items-center p-4 rounded-xl transition-all duration-200 hover:bg-white/80 text-gray-600 ${index === 0 ? "mt-2 border-t border-blue-100 pt-6" : ""}`}
                  >
                    <ExternalLink size={20} className="flex-shrink-0" />
                    <span className="ml-3 font-medium truncate">{item.name}</span>
                  </button>
                ))}


                <button
                  onClick={() => navigate("/")}
                  className="w-full flex items-center p-4 mt-6 text-red-600 border-t border-blue-100"
                >
                  <DoorOpen size={20} className="flex-shrink-0" />
                  <span className="ml-3 font-medium">Salir</span>
                </button>
              </nav>
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      <NewProject
        isOpen={showNewProjectModal}
        onClose={() => setShowNewProjectModal(false)}
        customerId={customerId}
        onSave={() => {
          setShowNewProjectModal(false);
          onProjectCreated();
        }}
      />
      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        customerId={customerId}
        onConfirm={() => setShowPaymentModal(false)}
      />
      <OnboardingSchedule
        isOpen={showOnboardingModal}
        onClose={() => setShowOnboardingModal(false)}
        customerId={customerId}
        onConfirm={() => setShowOnboardingModal(false)}
      />
      <InstallationSchedule
        isOpen={showInstallationModal}
        onClose={() => setShowInstallationModal(false)}
        customerId={customerId}
        onConfirm={() => setShowInstallationModal(false)}
      />
      <CustomerUsers
        isOpen={showUsersModal}
        onClose={() => setShowUsersModal(false)}
        customerId={customerId}
        onSave={() => {
          setShowUsersModal(false);
          onUserCreated();
        }}
      />  
      <CamDelivery
        isOpen={showCameraSetupModal}
        onClose={() => setShowCameraSetupModal(false)}
        customerId={customerId}
        onConfirm={() => setShowCameraSetupModal(false)}
      />
      <CustomerConfig
        isOpen={showCustomerConfigModal}
        onClose={() => setShowCustomerConfigModal(false)}
        customerId={customerId}
        customerData={customerData}
        onConfirm={() => setShowCustomerConfigModal(false)}
      />
      <ReinversionModal
        isOpen={showReferralModal}
        onClose={() => setShowReferralModal(false)}
        customerId={customerId}
      />
      <LicenseModal
        isOpen={showLicenseModal}
        onClose={() => setShowLicenseModal(false)}
      />

      {showLogoUploaderModal && (
        <LogoUploader
          customerId={customerId}
          onLogoSaved={handleLogoSaved}
          onLogoExport={(blob) => {
            console.log('Logo exportado:', blob);
            setShowLogoUploaderModal(false);
          }}
          onClose={() => setShowLogoUploaderModal(false)}
        />
      )}

      <CustomerContent
        isOpen={showContentModal}
        onClose={() => setShowContentModal(false)}
        customerId={customerId}
      />

      <ObrasModal
        isOpen={showObrasModal}
        onClose={() => setShowObrasModal(false)}
        customerId={customerId}
      />

      {showArchiveCamerasModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto"
          onClick={(e) => e.target === e.currentTarget && setShowArchiveCamerasModal(false)}
        >
          <div className="relative bg-white rounded-lg w-full max-w-7xl max-h-[90vh] flex flex-col overflow-hidden transition-all duration-300">
            <button
              onClick={() => setShowArchiveCamerasModal(false)}
              className="absolute right-4 top-2 text-gray-400 hover:text-gray-500 z-20"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <div className="p-4 flex-grow overflow-y-auto">
              <ArchiveCameras
                customerId={customerId}
                isOpen={showArchiveCamerasModal}
                onClose={() => setShowArchiveCamerasModal(false)}
              />
            </div>
            <div className="px-6 py-4 border-t flex justify-end">
              <button
                onClick={() => setShowArchiveCamerasModal(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default CustomerSidebar;